import React from 'react'
import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'

import {RadioButton} from 'src/components/form'

interface Props {
  selected?: boolean
  onSelect: () => void
  children?: React.ReactNode
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
`

const RadioContainer = styled.div`
  width: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  display: none;

  ${media.md`
    width: 56px;
    min-width: 56px;
    display: inherit;
  `}
`

export default function CreditCardRadioCard({
  selected,
  onSelect,
  children,
}: Props): JSX.Element {
  return (
    <Wrapper>
      <RadioContainer>
        <RadioButton checked={selected} onChange={onSelect} />
      </RadioContainer>
      {children}
    </Wrapper>
  )
}
